module.exports = __webpack_public_path__ + "static/img/logo.be50dde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 157
// module chunks = 1